export default __webpack_public_path__ + "static/media/CL04.2.14c282dc.mp3";